import { gatedContentFormOptions } from '@/components/react/form/forms/formOptions';
import {
  useAppForm,
  useGatedContentFormQuery,
} from '@/components/react/form/hooks/form';
import { COUNTRIES, getOptions } from '@/components/react/form/select-values';
import { ERROR_MESSAGES } from '@/components/react/form/translations/errorMessages';
import { INPUT_LABELS } from '@/components/react/form/translations/inputLabels';
import type { FormProviderProps } from '@/schemas/components/molecules/formSchema';
import { useEffect, useState, type FormEvent } from 'react';
import { GatedContentFormFields as GatedContentFormComponent } from './forms/GatedContentFormFields';

interface Location {
  hostname: string;
  pathname: string;
}

export const GatedContentForm = ({
  language,
  submitText,
}: FormProviderProps) => {
  const [sortedItems] = useState(getOptions(COUNTRIES, language));
  const [location, setLocation] = useState<Location>({
    hostname: '',
    pathname: '',
  });

  const { isError, mutateAsync } = useGatedContentFormQuery();
  const gatedContentForm = useAppForm({
    ...gatedContentFormOptions,
    onSubmit: async ({ value }) => {
      value.conversion_entry_page_full_most_recent = `${location.hostname}${location.pathname}`;

      return mutateAsync({ value });
    },
  });

  useEffect(() => {
    if (location.hostname === '' || location.pathname === '') {
      setLocation({
        hostname: window.location.hostname,
        pathname: window.location.pathname,
      });
    }
  }, [location]);

  return (
    <form
      onSubmit={(e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        gatedContentForm.handleSubmit();
      }}
      className="@container flex flex-col"
      id="gated-content-form"
    >
      {isError && (
        <div className="text-brand-error relative pb-4 text-base font-bold">
          {ERROR_MESSAGES.general[language]}
        </div>
      )}
      <GatedContentFormComponent
        form={gatedContentForm}
        sortedCountries={sortedItems}
        language={language}
      />
      <gatedContentForm.AppForm>
        <gatedContentForm.SubmitButton
          label={submitText || INPUT_LABELS.submit[language]}
        />
      </gatedContentForm.AppForm>
    </form>
  );
};
